import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import useSelectPatient from 'hooks/useSelectPatient'
import BaseGrinNotification from './BaseGrinNotification/BaseGrinNotification'
import GenericNotificationBody from './BaseGrinNotification/GenericNotificationBody'
import UrgentScanNotificationTitle from './UrgentScanNotificationTitle'
import { usePatientFromNotification } from './hooks/usePatientFromNotification'

/**
 * @param {NotificationComponentProps} props
 */
const UrgentScanNotification = ({ grinNotification, options }) => {
  const { t } = useTranslation()

  const selectPatient = useSelectPatient({
    patientId: grinNotification?.relatedPatientId,
    timelineItemId: grinNotification?.relatedEntityId
  })

  const handleClick = useCallback(() => {
    selectPatient()
  }, [selectPatient])

  const patient = usePatientFromNotification(grinNotification)

  return (
    <BaseGrinNotification
      grinNotification={grinNotification}
      isLastItem={options.isLastItem}
      showPracticeName={options.showPracticeName}
      profilePicture={patient?.profilePicture}
      profilePictureUserName={patient?.name}
      onClick={handleClick}
      dotIconColor="var(--urgent-scan-color)"
      customTitle={<UrgentScanNotificationTitle reason={grinNotification.payload.urgencyReason} />}
    >
      <GenericNotificationBody
        title={patient?.name || t('general.NA')}
        text={
          grinNotification.payload.alignerNumber
            ? t('dialogs.notificationCenterDialog.feed.notifications.newScan.withAligner', {
                scanNumber: grinNotification.payload.scanNumber,
                alignerNumber: grinNotification.payload.alignerNumber
              })
            : t('dialogs.notificationCenterDialog.feed.notifications.newScan.withoutAligner', {
                scanNumber: grinNotification.payload.scanNumber
              })
        }
      />
    </BaseGrinNotification>
  )
}

export default UrgentScanNotification
